import moment from 'moment';
import { Component } from 'react';
import { connect } from 'react-redux';
import '../../themes/confirm_hyg.scss';
import '../../themes/global.scss';
import { Link, useLocation, useParams } from 'react-router';
import { Avatar, Button, Column, DataRow, Row, Screen, Tooltip, Typography } from '@tempmee/react';
import { SolidInformationCircleIcon , OutlineBookmarkIcon, OutlineChatAlt2Icon, OutlineCheckCircleIcon, OutlineHeartIcon, OutlinePencilIcon, OutlineReceiptIcon, OutlineXCircleErrorIcon, OutlineXCircleIcon, SolidBookmarkIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { BackButton, CenteredSpinner, AmountRow, EdtBadge } from '~/commonComponents';
import { getIsAllowOfficeToPostProcedure } from '~/utils/DentistUtils';
import {
  ADD_FAVORITE_PROFESSIONAL,
  BLOCK_PROFESSIONAL,
  FETCH_JOBS_WITH_ADJUSTMENTS,
  FETCH_JOB_ACTION,
  addFavoriteProfessional,
  blockProfessional,
  fetchJob,
  fetchJobsWithAdjustmts,
  hideMessage,
} from '../../actions';
import { createErrorObjectSelector, createLoadingSelector } from '../../api/selectors';
import { IconButton } from '../../commonComponents/IconButton';
import { Links } from '../../constants';
import { PROMO_ROW_LABEL } from '~/constants/promo';
import { UserProfession, UserSubProfession } from '../../enums/UserProfession';
import { UserType } from '../../enums/UserType';
import { showCandidateOvertime } from '../../growthbook';
import { default as browserHistory, default as history } from '../../browserHistory';

import blockUserIcon from '../../images/block-user.svg';
import favoriteHeartSummary from '../../images/favorite-heart-summary.svg';

import { Colors } from '../../themes/colors';
import { getRedirectTarget } from '../../utils/AdjustmentUtil';
import { getProfessionalPayChargeDate } from '../../utils/chargeTimeline';
import { EducationUtils } from '../../utils/EducationUtils';
import { RemoteConfigUtils } from '../../utils/RemoteConfigUtils';
import CancelledJob from '../CancelledJob';
import { InviteButton } from '../ProfessionalsHub/components/InviteButton';
import { isEmployeeOptionShift } from '../WorkerClassification/utils';
import { HirePopupConfirmation } from '../PermanentJobsV2/JobOverview/components/CandidateTabView/CandidateListTable/HirePopup';
import { RejectPopupConfirmation } from '../PermanentJobsV2/JobOverview/components/CandidateTabView/CandidateListTable/RejectPopup';
import ConfirmPopup from '../shared/ConfirmPopup';
import { JobStatusInfo } from './JobStatusInfo';
import { jobCompletedByToday } from './utils';
import {
  useGetCandidateProfessional,
  useToggleShortlistCandidate,
} from '~/domain/PermanentJobs/useCases';
import { useToggle } from '~/hooks';

const InterviewActionButtons = ({ job }) => {
  const [showRejectPopup, rejectPopupControls] = useToggle(false);
  const [showHirePopup, hirePopupControls] = useToggle(false);

  const { data: candidateData } = useGetCandidateProfessional(
    {
      postingId: job?.postingId ?? '',
      professionalId: job?.offer_final_reciever?.id ?? '',
    },
    {
      enabled:
        job?.isOnsiteInterview &&
        (job?.status === 'complete' || job?.status === 'pay-out') &&
        !!job?.postingId &&
        !!job?.offer_final_reciever?.id,
    },
  );

  const { mutate: shortlistMutate } = useToggleShortlistCandidate({
    candidateId: candidateData?.id ?? '',
    isShortlisted: candidateData?.isShortlisted ?? false,
  });

  const professionalName = job?.offer_final_reciever?.full_name ?? '';
  const shouldShowInterviewActions = candidateData?.officeStatus === 'interviewed';

  return (
    <>
      {shouldShowInterviewActions && (
        <div
          style={{
            display: 'flex',
            columnGap: 12,
          }}
        >
          <div
            style={{
              width: 75,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              rowGap: 8,
            }}
          >
            <IconButton
              buttonStyle={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 50,
                height: 50,
                borderRadius: '50%',
                backgroundColor: Colors.neutral_100,
              }}
              Icon={<OutlineXCircleIcon size={24} color={colors.primary[500]} />}
              onClick={rejectPopupControls.setOn}
            />
            <p
              style={{
                fontFamily: 'Nunito',
                fontSize: 14,
                color: colors.neutral[600],
                textAlign: 'center',
                margin: 0,
              }}
            >
              Reject
            </p>
          </div>

          <div
            style={{
              width: 75,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              rowGap: 8,
            }}
          >
            <IconButton
              buttonStyle={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 50,
                height: 50,
                borderRadius: '50%',
                backgroundColor: colors.secondary[500],
              }}
              Icon={
                candidateData?.isShortlisted ? (
                  <SolidBookmarkIcon size={24} color={colors.shades[0]} />
                ) : (
                  <OutlineBookmarkIcon size={24} color={colors.shades[0]} />
                )
              }
              onClick={() => shortlistMutate()}
            />
            <p
              style={{
                fontFamily: 'Nunito',
                fontSize: 14,
                color: colors.neutral[600],
                textAlign: 'center',
                margin: 0,
              }}
            >
              {candidateData?.isShortlisted ? 'Shortlisted' : 'Shortlist'}
            </p>
          </div>

          <div
            style={{
              width: 75,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              rowGap: 8,
            }}
          >
            <IconButton
              buttonStyle={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 50,
                height: 50,
                borderRadius: '50%',
                backgroundColor: colors.primary[500],
              }}
              Icon={<OutlineCheckCircleIcon size={24} color={colors.shades[0]} />}
              onClick={hirePopupControls.setOn}
            />
            <p
              style={{
                fontFamily: 'Nunito',
                fontSize: 14,
                color: colors.neutral[600],
                textAlign: 'center',
                margin: 0,
              }}
            >
              Hire
            </p>
          </div>
        </div>
      )}

      {showRejectPopup && candidateData?.id && (
        <RejectPopupConfirmation
          controls={rejectPopupControls}
          candidateId={candidateData.id}
          professionalName={professionalName}
        />
      )}

      {showHirePopup && candidateData?.id && (
        <HirePopupConfirmation
          controls={hirePopupControls}
          candidateId={candidateData.id}
          professionalName={professionalName}
        />
      )}
    </>
  );
};

const convenienceFeeTooltip =
  'GoTu charges a 3.5% convenience fee on Credit Card transactions. If you do not wish to be charged the convenience fee, please update your billing to E-check/ACH.';

const overtimeTooltip =
  'Overtime pay (1.5x rate) is required for hours that exceed the state’s daily and/or weekly regular working hour limits.';

// Exported unconnected for unit tests; the app still uses the default
// JobDetailsWrapper export below.
export class JobDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFee: false,
      showCancellationPopup: false,
      showUnableToAddBlockedModal: false,
      showBlockConfirmPopup: false,
      isRedirected: false,
    };
  }

  componentDidMount() {
    const { jobId } = this.props.params;
    const { fetchJob } = this.props;

    fetchJob({ jobId });
  }

  componentDidUpdate() {
    const isPrevScreenFeedback = this.props.location.state?.isPrevScreenFeedback;

    const { job, history, isLoading } = this.props;
    const { isRedirected } = this.state;

    if (history.action !== 'POP') {
      if (job && !job.isFeedbackSubmited && !isLoading && !isRedirected && !isPrevScreenFeedback) {
        this.handleRedirectFeedback();
      }
    }
  }

  handleRedirectFeedback = () => {
    const { jobId } = this.props.params;
    const { adjustments } = this.props.job;

    if (!jobId || !adjustments) {
      return;
    }

    this.setState({
      isRedirected: true,
    });

    const redirectTarget = getRedirectTarget(adjustments);
    if (redirectTarget === 'feedback-rating') {
      history.push(`/dashboard/job/${jobId}/feedback-rating`);
    } else if (redirectTarget === 'feedback') {
      history.push(`/dashboard/job/${jobId}/feedback`);
    } else if (redirectTarget === 'adjustment') {
      this.props.fetchJobsWithAdjustmts();
    }
  };

  showEodButton = () => {
    const { job, user } = this.props;

    const isAdjustmentSent = job?.adjustments?.some(
      (adjustment) => adjustment?.author?.id === user?.id && adjustment?.status === 'none',
    );

    if (job.status === 'pay-out' && !job.isFeedbackSubmited && !isAdjustmentSent) {
      return (
        <div
          onClick={() => history.push(`/dashboard/job/${job?.id}/feedback`)}
          style={{
            position: 'absolute',
            top: '50%',
            right: '-25px',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
          }}
        >
          <OutlinePencilIcon size={24} color={colors.secondary[500]} />
        </div>
      );
    }
    return null;
  };

  addToFavorite = () => {
    const { addFavoriteProfessional, job, user } = this.props;
    const isBlocked = user?.blocked_hygienist?.includes(job?.offer_final_reciever?.id);

    if (isBlocked) {
      this.setState({ showUnableToAddBlockedModal: true });
    } else {
      addFavoriteProfessional(job?.offer_final_reciever?.id);
    }
  };

  blockProfessional = () => {
    const { job, blockProfessional } = this.props;

    this.setState({ showBlockConfirmPopup: false });
    blockProfessional({ user: job?.offer_final_reciever });
  };

  hygInfo = () => {
    const { user, job, history } = this.props;
    const isToday = moment(job?.local_date, 'ddd, MMM DD, YYYY').isSame(moment(), 'day');

    const hasProfessional = !!job?.offer_final_reciever;
    const isFavorite =
      job?.offer_final_reciever?.isFavorite ||
      user?.favoriteProfessionals?.includes(job?.offer_final_reciever?.id);
    const blockedProfessional = user?.blocked_hygienist?.includes(job?.offer_final_reciever?.id);
    const isJobCompletedByToday = jobCompletedByToday(job);
    const isCompletedOnsiteInterview =
      job?.isOnsiteInterview && (job?.status === 'complete' || job?.status === 'pay-out');

    return (
      <div
        style={{
          position: 'relative',
          backgroundColor: colors.shades[0],
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingTop: 50,
          paddingBottom: 30,
          boxShadow: '0px 3px 10px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.15)',
          zIndex: 1,
        }}
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              position: 'relative',
              width: '100%',
              alignItems: 'center',
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
            }}
          >
            <div style={{ paddingLeft: 32 }}>
              <BackButton />
            </div>

            <h1
              className="title global_font"
              style={{
                fontSize: 28,
                fontWeight: 700,
                textAlign: 'center',
                width: '100%',
                color: colors.neutral[600],
                flex: 1,
              }}
            >
              {job?.isOnsiteInterview ? 'Interview Summary' : 'Shift Summary'}
            </h1>

            <div
              style={{
                width: '100%',
                justifyContent: 'center',
                display: 'flex',
                columnGap: 24,
              }}
            >
              {!job?.isOnsiteInterview &&
                isToday &&
                !blockedProfessional &&
                job?.job_status === 'filled' && (
                  <div
                    style={{
                      width: 75,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      rowGap: 8,
                    }}
                  >
                    <InviteButton
                      user={{
                        id: job.offer_final_reciever?.id,
                        image: job.offer_final_reciever?.profile_image,
                        name: job.offer_final_reciever?.full_name,
                        profession: UserProfession.getCode(job.professionName),
                        professions: [UserProfession.getCode(job.professionName)],
                      }}
                      showTooltip={false}
                      position="bottom"
                      source={isToday ? 'dashboard' : undefined}
                    />
                    <p
                      style={{
                        fontFamily: 'Nunito',
                        fontSize: 14,
                        color: colors.neutral[600],
                        textAlign: 'center',
                        margin: 0,
                      }}
                    >
                      Invite Professional
                    </p>
                  </div>
                )}

              {this.chatBtnDisplay()}

              {isCompletedOnsiteInterview && <InterviewActionButtons job={job} />}

              {hasProfessional &&
                !isCompletedOnsiteInterview &&
                job?.status !== 'filled' &&
                job?.status !== 'cancelled' &&
                !isJobCompletedByToday && (
                  <div
                    style={{
                      display: 'flex',
                      columnGap: 32,
                    }}
                  >
                    <div
                      style={{
                        width: 75,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        rowGap: 8,
                      }}
                    >
                      <IconButton
                        buttonStyle={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: 50,
                          height: 50,
                          borderRadius: '50%',
                          backgroundColor: isFavorite ? Colors.primary_200 : colors.primary[500],
                        }}
                        Icon={<OutlineHeartIcon size={20} color={colors.shades[0]} />}
                        disabled={isFavorite}
                        onClick={this.addToFavorite}
                      />

                      <p
                        style={{
                          fontFamily: 'Nunito',
                          fontSize: 14,
                          color: isFavorite ? Colors.neutral_400 : colors.neutral[600],
                          textAlign: 'center',
                          margin: 0,
                        }}
                      >
                        {isFavorite ? 'Added to Favorites' : 'Add to Favorites'}
                      </p>
                    </div>

                    <div
                      style={{
                        width: 50,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        rowGap: 8,
                      }}
                    >
                      <IconButton
                        buttonStyle={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: 50,
                          height: 50,
                          borderRadius: '50%',
                          backgroundColor: blockedProfessional
                            ? Colors.secondary_200
                            : colors.secondary[500],
                        }}
                        src={blockUserIcon}
                        imgStyle={{
                          width: 24,
                          height: 24,
                        }}
                        onClick={() => this.setState({ showBlockConfirmPopup: true })}
                        disabled={blockedProfessional}
                      />

                      <p
                        style={{
                          fontFamily: 'Nunito',
                          fontSize: 14,
                          color: blockedProfessional ? Colors.neutral_400 : colors.neutral[600],
                          textAlign: 'center',
                          margin: 0,
                        }}
                      >
                        {blockedProfessional ? 'Blocked Professional' : 'Block Professional'}
                      </p>
                    </div>
                  </div>
                )}
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              columnGap: '20px',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <div
              style={{
                position: 'relative',
                display: 'flex',
                border: job?.offer_final_reciever?.isFavorite ? '3px solid #B764EB' : 'none',
                borderRadius: '50%',
                padding: 3,
              }}
            >
              <Avatar
                size="2xl"
                src={job?.offer_final_reciever?.profile_image || undefined}
                alt="profile_image"
              />

              {job?.offer_final_reciever?.isFavorite && (
                <img
                  src={favoriteHeartSummary}
                  style={{ position: 'absolute', top: '65%', left: '70%' }}
                  alt="favorite_heart_summary"
                />
              )}
            </div>
            {hasProfessional ? (
              <div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span
                    className="global_font f-20"
                    style={{ color: colors.neutral[600], fontWeight: 'bold', marginRight: 10 }}
                  >
                    {`${job.offer_final_reciever?.first_name || ''} ${
                      job.offer_final_reciever?.last_name || ''
                    }`}{' '}
                    |
                  </span>

                  <div
                    className="global_font f-20"
                    style={{
                      marginLeft: 20,
                      color: colors.secondary[500],
                      fontWeight: 'bold',
                      margin: 0,
                      cursor: 'pointer',
                    }}
                    onClick={() =>
                      history.push(`/dashboard/candidate/${job?.id}`, {
                        candidateId: job?.offer_final_reciever?.id,
                        state: job?.state,
                        profession: job?.profession,
                      })
                    }
                  >
                    Profile
                  </div>
                </div>
                <p className="global_font std_font" style={{ color: colors.neutral[600] }}>
                  {UserSubProfession.getName(job?.subProfession) || job.professionName || ''}
                </p>
                {job.offer_final_reciever.license?.license ? (
                  <p className="global_font std_font" style={{ color: colors.neutral[600] }}>
                    License: {job.offer_final_reciever.license?.license || ''}
                  </p>
                ) : (
                  <div />
                )}
                <p className="global_font std_font" style={{ color: colors.neutral[600] }}>
                  {job.offer_final_reciever.address[0].formatted_address}
                </p>
              </div>
            ) : (
              <div>
                <span
                  className="global_font f-20"
                  style={{ color: colors.neutral[600], fontWeight: 'bold', marginLeft: -24 }}
                >
                  Shift Unfilled
                </span>
              </div>
            )}
          </div>

          {this.state.showUnableToAddBlockedModal && (
            <ConfirmPopup
              title="Unable to Add to Favorites"
              description="To add this professional to your Favorites, please contact Customer Support to remove this professional from your blocked list."
              rightButtonText="Close"
              rightButtonAction={() => this.setState({ showUnableToAddBlockedModal: false })}
            />
          )}
        </div>
      </div>
    );
  };

  handleLearnMore = () => {
    window.open(Links.bankPayments);
    this.setState({ showFee: false });
  };

  handleOKClicked = () => {
    this.setState({ showFee: false });
  };

  cancelBtnDisplay = () => {
    const { job } = this.props;
    const currentTime = new Date();

    if (
      job.job_status === 'filled' &&
      !job.is_cancelled &&
      moment(job.job_datetime).toDate() > currentTime
    ) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 8,
          }}
        >
          <Button
            variant="outlined"
            size="lg"
            onClick={() => this.setState({ showCancellationPopup: true })}
          >
            {job?.isOnsiteInterview ? 'Cancel Interview' : 'Cancel Shift'}
          </Button>
        </div>
      );
    }

    return <></>;
  };

  transactionHistoryBtn = () => {
    const { job } = this.props;

    if (
      job?.transactions?.length &&
      (job.status === 'filled' ||
        job.status === 'complete' ||
        job.status === 'pay-out' ||
        job.status === 'cancelled')
    ) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 8,
          }}
        >
          <Button
            size="lg"
            LeadingIcon={<OutlineReceiptIcon size={24} />}
            onClick={() => history.push(`/dashboard/receipts/transactions/${job?.id}`)}
          >
            Transaction History
          </Button>
        </div>
      );
    }

    return <></>;
  };

  renderSharedFeeRows = () => {
    const { job } = this.props;
    return (
      <>
        <AmountRow
          label={job.tm_fee_percent !== 0 ? `Service Fee (${job.tm_fee_percent}%):` : 'Service Fee:'}
          amount={job.tm_fee}
        />
        {isEmployeeOptionShift(job) && (
          <AmountRow
            label="Employee Fee:"
            amount={job.employeeOptionFee || undefined}
            emptyText="$--.--"
          />
        )}
        {job.convenience_fee_percent !== 0 ? (
          <AmountRow
            label={`Convenience Fee (${job.convenience_fee_percent.toFixed(1) || '0'}%):`}
            amount={job.convenience_fee}
            icon={
              <Tooltip title={convenienceFeeTooltip}>
                <SolidInformationCircleIcon color={colors.neutral[300]} />
              </Tooltip>
            }
          />
        ) : null}
      </>
    );
  };

  renderFilledJobInfo = () => {
    const { job } = this.props;
    const chargeDate = moment(getProfessionalPayChargeDate(job?.job_datetime)).format('MM/DD/YYYY');
    const startDiff = moment(job?.job_datetime).diff(moment(), 'days');
    return (
      <>
        {!showCandidateOvertime() ? (
          <AmountRow
            label={`Professional Pay ${job?.totalHours?.toFixed(2)} hours:`}
            amount={job.amount}
          />
        ) : (
          <>
            {job?.regularAndOvertimeHours?.regular > 0 && job?.totalRegular > 0 && (
              <AmountRow
                label={`Regular Rate Pay (${job?.regularAndOvertimeHours?.regular?.toFixed(
                  2,
                )} hrs):`}
                amount={job?.totalRegular}
              />
            )}
            {job?.regularAndOvertimeHours?.overtime > 0 && job?.totalOvertime > 0 && (
              <AmountRow
                label={`Overtime Pay (${job?.regularAndOvertimeHours?.overtime?.toFixed(2)} hrs):`}
                amount={job?.totalOvertime}
                icon={
                  <Tooltip title={overtimeTooltip}>
                    <SolidInformationCircleIcon color={colors.neutral[300]} />
                  </Tooltip>
                }
              />
            )}
          </>
        )}
        {this.renderSharedFeeRows()}
        {job?.multi_day_booking && startDiff > 28 ? (
          <DataRow divider={false} label="Professional pay charge date" value={chargeDate} />
        ) : (
          <div />
        )}

        {job.counterCover ? (
          <AmountRow label="GoTu Counter Cover" amount={job.counterCover.amount} variant="credit" />
        ) : null}

        {job.promoDiscount?.amount ? (
          <AmountRow label={PROMO_ROW_LABEL} amount={job.promoDiscount.amount} variant="credit" />
        ) : null}

        <AmountRow label="Total Pay:" amount={job.total} variant="total" />
        {job?.cancelPerformedBy && (
          <DataRow divider={false}
            label="Cancelled by:"
            value={`${job?.cancelPerformedBy?.first_name || ''} ${
              job?.cancelPerformedBy?.last_name || ''
            }`}
          />
        )}
        {job?.confirmPerformedBy && (
          <DataRow divider={false}
            label="Scheduled By:"
            value={`${job?.confirmPerformedBy?.first_name || ''} ${
              job?.confirmPerformedBy?.last_name || ''
            }`}
          />
        )}
      </>
    );
  };

  renderFilledCancelledJobInfo = () => {
    const { job } = this.props;
    return (
      <div>
        <AmountRow label="Cancellation Fee:" amount={job.cancellation_fee} />
        {this.renderSharedFeeRows()}
        <AmountRow
          amount={job.total_refund}
          label={`Refund Total ${job.card_name} *${job.card_number}`}
          variant="total"
        />
      </div>
    );
  };

  chatBtnDisplay = () => {
    const { job, history } = this.props;
    const currentTime = new Date();
    if (
      job.job_status === 'filled' &&
      !job.is_cancelled &&
      moment(job.job_datetime_end).toDate() > currentTime &&
      job.offer_final_reciever
    ) {
      return (
        <div
          style={{
            width: 75,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            rowGap: 8,
          }}
        >
          <IconButton
            buttonStyle={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 50,
              height: 50,
              borderRadius: '50%',
              backgroundColor: colors.secondary[500],
            }}
            Icon={<OutlineChatAlt2Icon size={24} color={colors.shades[0]} />}
            onClick={() => {
              history.push(`/dashboard/chat/${job?.id}`, { jobId: job?.id });
            }}
          />

          <p
            style={{
              fontFamily: 'Nunito',
              fontSize: 14,
              color: colors.neutral[600],
              textAlign: 'center',
              margin: 0,
            }}
          >
            Contact Professional
          </p>
        </div>
      );
    }

    return <></>;
  };

  renderSummaryContent = () => {
    const { job } = this.props;

    if (job.status === 'filled' || job.status === 'complete' || job.status === 'pay-out') {
      return this.renderFilledJobInfo();
    }
    if (job.status === 'cancelled' && job.offer_final_reciever) {
      return this.renderFilledCancelledJobInfo();
    }

    return <></>;
  };

  render() {
    const { job, isLoading, childOffices } = this.props;

    const { procedures: _procedures } = job || {};

    const procedures = _procedures ?? [];

    const { showCancellationPopup, showBlockConfirmPopup } = this.state;

    if (isLoading || !job) {
      return (
        <Screen variant="standard">
          <Screen.Body>
            <CenteredSpinner minHeight={400} />
          </Screen.Body>
        </Screen>
      );
    }
    // eslint-disable-next-line max-len
    const professionalName = `${job?.offer_final_reciever?.first_name} ${job?.offer_final_reciever?.last_name}`;
    const isFavorite = job?.offer_final_reciever?.isFavorite;
    const isCanceledByProfessional = job?.is_cancelled_by_user_type === UserType.HYG;
    const autoFillTooltipDescription = (
      <>
        Professional’s eligibility criteria:
        <br />
        <br />
        {'\u2022  '}
        Has at least a {RemoteConfigUtils.getAutofillMinAttendanceScore()}% attendance score for
        previous shifts worked.
        <br />
        {'\u2022  '}
        Has a minimum of 2 years working experience.
        <br />
        {'\u2022  '}
        Has received exceptional performance ratings on over 95% of completed shifts.
        <br />
        {'\u2022  '}
        Has completed at least 3 shifts.
        <br />
        <br />
        Note: You may change your auto-confirm preference at any time by visiting the Shift Details
        page.
      </>
    );

    return (
      <>
        <Screen
          variant="top-card"
          ref={(element) => (this.divRef = element)}
          bodyCardClassName="bg-transparent p-0 shadow-none mx-0"
        >
          <Screen.Body>
            {this.hygInfo()}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '0 16px 16px 16px',
                background: colors.shades[0],
                boxShadow:
                  '0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.15)',
              }}
            >
              <div
                style={{
                  width: 500,
                  display: 'flex',
                  flexDirection: 'column',
                  marginTop: 40,
                  paddingBottom: 60,
                }}
              >
                <JobStatusInfo job={job} />

                {childOffices.length !== 0 ? (
                  <div className="row_style">
                    <p
                      className="global_font bold_font"
                      style={{ margin: 0, color: colors.neutral[600] }}
                    >
                      Office:
                    </p>
                    <p
                      className="global_font"
                      style={{ margin: 0, color: colors.neutral[600], fontSize: 18 }}
                      data-cy="shift-detail-office-name"
                    >
                      {job.offer_owner?.office_name}
                    </p>
                  </div>
                ) : (
                  <div />
                )}

                {job?.isOnsiteInterview && (
                  <Row className="row_style">
                    <Typography as="span" bold>
                      Job Title:
                    </Typography>
                    <Column align="center">
                      <Link to={`/permanent-jobs/job-overview/${job?.postingId}`}>
                        <Typography as="span" style={{ fontSize: 18, textDecoration: 'underline' }}>
                          {job?.postingTitle}
                        </Typography>
                      </Link>
                    </Column>
                  </Row>
                )}

                <DataRow divider={false} label="Date:" value={job.local_date} />

                <DataRow divider={false}
                  label="Professional Type:"
                  value={UserSubProfession.getName(job?.subProfession) || job.professionName || ''}
                />

                <DataRow divider={false}
                  label="Preferred Specialty:"
                  value={job?.specialty?.split('_')?.[1] || 'General'}
                />

                {getIsAllowOfficeToPostProcedure(
                  UserSubProfession.getName(job?.subProfession) ?? job?.professionName,
                  job?.specialty,
                ) &&
                  procedures.length > 0 && (
                    <div
                      style={{
                        borderBottom: '1px solid #ededed',
                      }}
                    >
                      <div
                        className="row_style"
                        style={{
                          border: 0,
                        }}
                      >
                        <p
                          style={{
                            margin: 0,
                            color: colors.neutral[600],
                            fontSize: 18,
                          }}
                        >
                          <b>Procedures:</b>
                        </p>
                      </div>

                      <ul
                        style={{
                          color: colors.neutral[600],
                          fontSize: 18,
                          marginTop: 0,
                        }}
                      >
                        {EducationUtils.mapToRemoveProcedurePrefix(procedures).map((procedure) => (
                          <li key={procedure}>{procedure}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                <DataRow divider={false}
                  label="Hours:"
                  icon={<EdtBadge>{job.local_timezone}</EdtBadge>}
                  value={
                    <Row align="center" gap={2} justify="end">
                      <span>{`${job.local_start_time} - ${job.local_end_time}`}</span>
                      {this.showEodButton()}
                    </Row>
                  }
                />

                <AmountRow label="Hourly Rate:" amount={job.rate} />
                <DataRow divider={false}
                  label="Meal Break:"
                  value={`${job.lunch_break_time} min ${
                    job.is_lunch_break_paid ? '(Paid)' : '(Unpaid)'
                  }`}
                />

                {!job?.isOnsiteInterview && (
                  <div
                    className="row_style"
                    style={{
                      alignItems: 'flex-start',
                    }}
                  >
                    <span
                      className="global_font bold_font"
                      style={{ margin: 0, color: Colors.DarkGray }}
                    >
                      Auto-Confirm:
                      <span style={{ marginLeft: '5px' }}>
                        <Tooltip content={autoFillTooltipDescription}>
                          <SolidInformationCircleIcon color={colors.neutral[300]} />
                        </Tooltip>
                      </span>
                    </span>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 12,
                        color: colors.neutral[600],
                        fontSize: 18,
                        textAlign: 'end',
                      }}
                    >
                      <span>Favorites / {job.autofillOptions?.favorite ? 'On' : 'Off'}</span>
                      <span>Eligible Professionals / {job.autoFill ? 'On' : 'Off'}</span>
                    </div>
                  </div>
                )}

                {job?.cancelPerformedBy && (
                  <DataRow divider={false}
                    label="Cancelled by:"
                    value={`${job?.cancelPerformedBy?.first_name || ''} ${
                      job?.cancelPerformedBy?.last_name || ''
                    }`}
                  />
                )}

                {isCanceledByProfessional ? (
                  <span
                    style={{
                      fontFamily: 'Nunito',
                      color: colors.neutral[600],
                      fontSize: 16,
                      fontWeight: 700,
                      textAlign: 'center',
                      marginTop: 40,
                    }}
                  >
                    *This {job?.isOnsiteInterview ? 'interview' : 'shift'} has been re-posted*
                  </span>
                ) : (
                  <>
                    {this.renderSummaryContent()}

                    <div
                      style={{
                        marginTop: 40,
                      }}
                    >
                      {this.transactionHistoryBtn()}

                      {this.cancelBtnDisplay()}
                    </div>
                  </>
                )}
              </div>
            </div>
          </Screen.Body>
        </Screen>
        {showCancellationPopup ? (
          <CancelledJob closePopup={() => this.setState({ showCancellationPopup: false })} />
        ) : null}
        {showBlockConfirmPopup && (
          <ConfirmPopup
            title="Block Professional"
            description={
              isFavorite
                ? // eslint-disable-next-line max-len
                  `To block this professional, they must be removed from your Favorites list. Would you like to continue with removing ${professionalName} from your Favorites and blocking them?`
                : 'Are you sure you want to block this professional from working with you again?'
            }
            leftButtonText="Go Back"
            leftButtonAction={() => this.setState({ showBlockConfirmPopup: false })}
            rightButtonText="Continue"
            rightButtonAction={this.blockProfessional}
            Icon={() => <OutlineXCircleErrorIcon />}
            closePopup={() => this.setState({ showBlockConfirmPopup: false })}
          />
        )}
      </>
    );
  }
}
const actions = [
  FETCH_JOB_ACTION,
  ADD_FAVORITE_PROFESSIONAL,
  BLOCK_PROFESSIONAL,
  FETCH_JOBS_WITH_ADJUSTMENTS,
];
const loadingSelector = createLoadingSelector(actions);
const errorSelector = createErrorObjectSelector(actions);

const mapStateToProps = (state, props) => ({
  error: errorSelector(state),
  job: props.params?.jobId === state.job.job?.id ? state.job.job : null,
  isLoading: loadingSelector(state),
  user: state.user.user,
  favoriteProfessionals: state.user.favoriteProfessionals,
  childOffices: state.user.childOffices,
});

const JobDetailsWrapper = () => {
  const params = useParams();
  const location = useLocation();
  return <ConnectedJobDetails params={params} location={location} history={browserHistory} />;
};

const ConnectedJobDetails = connect(mapStateToProps, {
  fetchJob,
  hideMessage,
  addFavoriteProfessional,
  blockProfessional,
  fetchJobsWithAdjustmts,
})(JobDetails);

export default JobDetailsWrapper;
